import LoginPageBody from './LoginPageBody'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import './Login.css'
import { ICSModal } from '../../components'

const LoginPage = () => {
  return (
    <div
      id="login-background"
      className="fade show"
      role="dialog"
      tabIndex={-1}
    >
      <ICSModal
        id="login_container"
        modalId="login_modal"
        visible={true}
        onHiding={() => {
          return
        }}
        defaultWidth={325}
        closeOnOutsideClick={false}
        position={{
          of: "window",
          at: "top center",
          collision: "fit",
          boundaryOffset: "0 100"
        }}
      >
        <ModalHeader
          className={'ics-modal-header'}
          id="login_img"
        ></ModalHeader>
        <ModalBody className="ics-modal-body form-control" id="login_body">
          <LoginPageBody />
        </ModalBody>
      </ICSModal>
    </div>
  )
}

export default LoginPage
